"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isURL = void 0;
const url_1 = require("url");
exports.isURL = (value) => value instanceof url_1.URL;
//# sourceMappingURL=is-url.js.map